import { FETCH_JOKL_USERS, CLEAN_JOKL_USERS, CHANGE_JOKL_USER_STATUS } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const JOKL_USERS_DEFAULT_STATE = {};

const JoklUsersReducer = (state = JOKL_USERS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_JOKL_USERS:
            return payload;

        case CHANGE_JOKL_USER_STATUS:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: payload.status };
                }

                return item;
            }) };

        case CLEAN_JOKL_USERS:
            return JOKL_USERS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default JoklUsersReducer;
